import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { Result } from "antd";
import { VisualizarDocumentoHTML } from "./VisualizarDocumentoHTML";
import { useQuery } from "@tanstack/react-query";
import { DocumentoService } from "../Services/Domain/Documentos/DocumentoService";
import { Download } from "./Download";

const NotFound = () => <Result status={"404"} title="Não encontrado" subTitle="O recurso que você está procurando não existe neste servidor ou expirou." />;

export const Documentos: React.FC<{}> = () => {
    const { token } = useParams();

    const query = useQuery({
        queryKey: [token],
        queryFn: () => (token == undefined ? Promise.reject() : DocumentoService.obterRecursoCompartilhado(token)),
        retry: false,
        enabled: token != undefined,
    });

    const [text, setText] = useState<string | undefined>()
    useEffect(() => {
        if((query.data?.headers["content-type"] as string | undefined)?.startsWith("text/")){
            query.data?.data.text().then(setText)
        }
    }, [query])

    const mimetype = query.data?.headers["content-type"] as string | undefined ?? "application/octet-stream"
    const bytes = Number(query.data?.headers["content-length"]) ?? 0;
    const filename = (query.data?.headers["content-disposition"] as string | undefined)?.split(";").map((v) => v.trim()).map((v) => v.split("=")).find(([k, v]) => k == "filename") ?.at(1) ?? "download";

    if (token == undefined) {
        return <NotFound />;
    }

    return (
        <div style={{height: "100vh"}}>
            {
                query.isPending ? (
                    <>Carregando...</>
                ) : query.isError ? (
                    <NotFound />
                ) : query.data?.data == undefined ? (
                    <Result status={"error"} />
                ) : query.data.headers["content-type"] == "text/html" ? (
                    text? <VisualizarDocumentoHTML html={text} /> : <></>
                ) : (
                    <Download data={query.data.data} mimetype={mimetype} filename={filename} bytes={bytes} />
                )
            }
        </div>
    );
};
